const initializeAllCountryOptionsWithMarketoOptions = require("./initializeAllCountryOptionsWithMarketoOptions");
const listenToCountrySelectUpdates = require("./listenToCountrySelectUpdates");

/**
 * @param onUpdated {(countrySelect: HTMLSelectElement) => void}
 * @return {Promise<void>}
 */
module.exports = async function initCountrySelects(onUpdated) {
    await initializeAllCountryOptionsWithMarketoOptions();
    listenToCountrySelectUpdates(onUpdated);
}